module.exports = __webpack_public_path__ + "static/media/terms.20d66039.pdf";